/**
 * User Account Routes
 *
 * Routes for user profile, top-up, usage, receipts, and payment
 */

import React from "react";
import { Route } from "react-router-dom";
import {
  ApiKeysPage,
  UserPage,
  TopUpPage,
  ViewUsagePage,
  ReceiptsPage,
  ReceiptDetailPage,
  PaymentSuccessPage,
  PaymentCancelPage,
} from "../lazyComponents";
import { getCommonProps } from "./routeConfig";
import ProtectedRoute from "../../components/auth/ProtectedRoute";

/**
 * Gets all user account-related routes
 * @param {Object} props - Props from parent component
 * @returns {Array} Array of Route elements
 */
export const getUserRoutes = ({ getProfileProps, getComponentProps }) => {
  const profileProps = getProfileProps();
  const componentProps = getComponentProps();

  return [
    // User profile (protected)
    <Route
      key="profile"
      path="/profile"
      element={
        <ProtectedRoute>
          <UserPage {...profileProps} {...getCommonProps()} />
        </ProtectedRoute>
      }
    />,

    <Route
      key="api-keys"
      path="/profile/api-keys"
      element={
        <ProtectedRoute>
          <ApiKeysPage {...componentProps} {...getCommonProps()} />
        </ProtectedRoute>
      }
    />,

    // Top-up credits (public - allows guest browsing before login)
    <Route
      key="topup"
      path="/topup"
      element={<TopUpPage {...componentProps} {...getCommonProps()} />}
    />,

    // View usage (protected)
    <Route
      key="usage"
      path="/usage"
      element={
        <ProtectedRoute>
          <ViewUsagePage {...componentProps} {...getCommonProps()} />
        </ProtectedRoute>
      }
    />,

    // Receipts list (protected)
    <Route
      key="receipts"
      path="/receipts"
      element={
        <ProtectedRoute>
          <ReceiptsPage {...componentProps} {...getCommonProps()} />
        </ProtectedRoute>
      }
    />,

    // Receipt detail (protected)
    <Route
      key="receipt-detail"
      path="/receipts/:receiptId"
      element={
        <ProtectedRoute>
          <ReceiptDetailPage {...componentProps} {...getCommonProps()} />
        </ProtectedRoute>
      }
    />,

    // Payment success (protected)
    <Route
      key="payment-success"
      path="/payment/success"
      element={
        <ProtectedRoute>
          <PaymentSuccessPage {...componentProps} {...getCommonProps()} />
        </ProtectedRoute>
      }
    />,

    // Payment cancel (protected)
    <Route
      key="payment-cancel"
      path="/payment/cancel"
      element={
        <ProtectedRoute>
          <PaymentCancelPage {...componentProps} {...getCommonProps()} />
        </ProtectedRoute>
      }
    />,
  ];
};
